import { TrendingUp } from "lucide-react";

const fmt = (n) => (n || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });

function Row({ label, value, testId, negative = true }) {
  return (
    <div className="flex justify-between text-sm text-zinc-600">
      <span>{label}</span>
      <span className="tabular-nums" data-testid={testId}>{negative ? `− ${fmt(value)}` : fmt(value)}</span>
    </div>
  );
}

export const JobProfitSummary = ({ invoice, isContractor, materials }) => {
  const total = invoice.total || 0;
  const tax = invoice.tax || 0;
  const people = isContractor ? invoice.contractor_payout || 0 : invoice.labor_cost || 0;
  const profit = total - tax - materials - people;
  const margin = total > 0 ? (profit / total) * 100 : 0;
  const loss = profit < 0;

  return (
    <div className="mt-3 pt-3 border-t border-green-200 space-y-1" data-testid="job-profit-summary">
      <div className="text-sm font-semibold text-zinc-800 flex items-center gap-1.5 mb-1">
        <TrendingUp className="w-4 h-4 text-[#207024]" /> Job Profit
      </div>
      <Row label="Invoice total" value={total} negative={false} testId="profit-invoice-total" />
      {tax > 0 && <Row label="Sales tax" value={tax} testId="profit-tax" />}
      <Row
        label={isContractor ? "Materials (in contractor payout)" : "Materials"}
        value={materials}
        testId="profit-materials"
      />
      <Row label={isContractor ? "Contractor payout" : "Labor"} value={people} testId="profit-labor" />
      <div
        className={`flex justify-between items-baseline pt-2 mt-1 border-t border-dashed ${loss ? "border-red-200" : "border-green-300"}`}
      >
        <span className={`font-bold ${loss ? "text-red-700" : "text-green-800"}`}>Profit</span>
        <span className="text-right">
          <span className={`text-lg font-bold tabular-nums ${loss ? "text-red-600" : "text-green-700"}`} data-testid="profit-value">
            {fmt(profit)}
          </span>
          <span className="ml-2 text-xs text-zinc-500" data-testid="profit-margin">{margin.toFixed(1)}%</span>
        </span>
      </div>
    </div>
  );
};
